/**
 * @typedef {1|2|3} tab 月度、季度、年度
 */

/**
 * 设备故障趋势分析
 * @param {数据源} chartData 
 * @param {tab} tab 月度、季度、年度
 * @returns {import('echarts').EChartsOption}
 */
export default function (chartData = [], tab) {

  // x轴数据
  const xData = chartData.map(item => item.date)

  // 系列数据
  const alarmNum = chartData.map(item => item.alarmNum)
  const orderNum = chartData.map(item => item.orderNum)


  const barWidth = tab == 2 ? 3 : 12;

  /**
   * @type {import('echarts').EChartsOption}
   */
  const option = {
    title: {
      text: '设备故障趋势分析',
      subtext: '按选定时间统计故障次数和工单次数',
      left: 20,
      top: 10,
      textStyle: {
        color: '#000',
        fontSize: 16,
        fontWeight: 500,
        fontFamily: 'HarmonyOS Sans SC',
      }
    },
    color: ['#3E82EF', '#55DF6A'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    grid: {
      top: 80,
      bottom: 60,
      left: 80,
      right: 40,
    },
    legend: {
      right: 60,
      top: 20,
      itemWidth: 10,
      itemHeight: 10,
      // data: ['Evaporation', 'Precipitation', 'Temperature']
    },
    xAxis: [
      {
        type: 'category',
        data: xData,//['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        axisPointer: {
          type: 'shadow'
        },
        axisLine: {
          show: false
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        // name: '次数',
        // min: 0,
        // max: 250,
        // interval: 50,
        axisLabel: {
          formatter: '{value} 条'
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          }
        }
      },
    ],
    series: [
      {
        name: '故障数',
        type: 'bar',
        tooltip: {
          valueFormatter: function (value) {
            return value + ' 条';
          }
        },
        // 季度时 条形宽度为8
        barWidth: barWidth,
        data: alarmNum,
        itemStyle: {
          // [左上角, 右上角, 右下角, 左下角]
          borderRadius: [4, 4, 0, 0]
        }
      },
      {
        name: '工单数',
        type: 'bar',
        tooltip: {
          valueFormatter: function (value) {
            return value + ' 条';
          }
        },
        barWidth: barWidth,
        data: orderNum,
        itemStyle: {
          // [左上角, 右上角, 右下角, 左下角]
          borderRadius: [4, 4, 0, 0]
        }
      },
      // {
      //   name: 'Temperature',
      //   type: 'line',
      //   yAxisIndex: 1,
      //   tooltip: {
      //     valueFormatter: function (value) {
      //       return value + ' °C';
      //     }
      //   },
      //   data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
      // }
    ]
  };


  return option
}

